<template>
  <div class="gs-app gs-self-billing-page">
    <div class="gs-self-billing-page__content">
      <v-wait for="dashboard">
        <div class="gs-self-billing-page__state">
          {{ $t('frontend_coming_soon') }}
        </div>
      </v-wait>
    </div>
  </div>
</template>

<script>
export default {
  middleware: 'auth',
  metaInfo() {
    return { title: 'Self Billing' };
  },
};
</script>

<style scoped>
.gs-self-billing-page {
  min-height: 100%;
  padding: 28px;
  color: var(--gs-foreground);
  background: var(--gs-background);
}

.gs-self-billing-page__content {
  max-width: 960px;
  margin: 0 auto;
}

.gs-self-billing-page__state {
  padding: 40px 24px;
  text-align: center;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

@media (max-width: 640px) {
  .gs-self-billing-page {
    padding: 16px;
  }
}
</style>
